<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- selling contents -->
        <div class="container">
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>

            <!-- show pagination dropdown -->
            <div v-if="countRecords" class="row mt-2">
                <div class="col-lg-3 col-md-4 col-sm-5 col-12">
                    <router-link :to="{ name: 'anewitem' }" class="btn btn-dark-green form-control">
                        <i class="fas fa-camera"></i> Post a New Item
                    </router-link>
                </div>
                <div class="col-lg-9 col-md-8 col-sm-7 col-12 text-center text-sm-right pt-2">
                    Showing 
                    <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                        <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                    </select> 
                    of {{countRecords.total}} Items
                </div>
            </div>

            <!-- show my posted items -->
            <template v-if="mySellings">
                <div class="row">
                    <app-user-item v-for="(item, i) in mySellings" :key="i" :item="item" :sn="i+1" :selling="true"></app-user-item>
                </div>
            </template>
            <template v-else>
                <div class="row my-5">
                    <div class="col-12 text-muted">
                        <center>
                            <i class="far fa-frown fa-5x my-3"></i>
                            <h5>You don't seem to have posted any item yet, {{user.name | capitalize}}</h5>
                            <router-link :to="{ name: 'anewitem' }" class="btn btn-dark-green my-5">
                                <i class="fas fa-camera"></i> Post your first item here
                            </router-link>
                        </center>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { paginateRecords } from '@/store/dry'

import Account from '../shared/Account.vue'
import UserItem from '@/components/user/shared/UserItem.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Selling",
    data() {
        return {
            color: 'danger',
            msg: '',
            postsLimit: process.env.VUE_APP_BSC_POST_LIMIT,
            recordsLimit: 0,
        }
    },
    methods: {
        ...mapActions(['itemsIamSelling']),
        modifyLimit(limit) {
            this.recordsLimit = limit
        },
        fetchItemsIamSelling() {
            this.itemsIamSelling()
            .then((data) => {
                if(data.msg){
                    this.color = !data.error ? 'success' : 'danger'
                    this.msg = data.msg
                }
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'sellings']),
        mySellings() {
            if(this.sellings && this.sellings !== null){
                return this.sellings.slice(0, this.recordsLimit)
            }
            return false
        },
        countRecords() {
            if(this.sellings && this.sellings.length){
                let shopAllowedItems = this.sellings
                // ensure non-shop+ seller items never exceeds the shop allowed items limit
                if(!this.user.shopOwner && this.sellings.length > this.postsLimit){
                    shopAllowedItems = this.sellings.slice(0, this.postsLimit)
                }
                let resultObj = paginateRecords(shopAllowedItems, 11)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        },
    },
    components: {
        appUserItem: UserItem,
        appAccount: Account
    },
    created() {
        this.fetchItemsIamSelling()
        this.$emit('update:layout', LayoutUser);
    }
}
</script>